import {
  ajax
} from 'application/src/js/functions.js';
import NewsItem from 'application/src/js/landingpage/shared/news.js';

/**
 * @class
 * @param {number} args.basicIds
 * @param {object} args.translations
 * @param {Mediator} args.mediator
 */
export default class NewsList {
  constructor(args) {
    this.basicIds = args.basicIds;
    this.translations = args.translations;
    this.mediator = args.mediator;

    this.container = document.querySelector('.lp-content .news');
    this.topNewsContainer = this.container.querySelector('.top-news-container');
    this.secondaryNewslist = this.container.querySelector('.secondary-news-container .list');

    this.requestUrl = '/app/ajax/ajaxLoadRelatedNews';
    this.user = null;
    this.debugMode = true;
    this.hideClass = 'hide';
    this.showTopNews = false;

    this.load()
      .then(response => {
        this.user = response.user;
        this.showTopNews = response.data.length >= 4;
        this.render(response.data);
        this.mediator.publish('finishedLoading');
      })
      .catch(e => {
        if (this.debugMode && e) console.log(e);
        this.mediator.publish('finishedLoading');
      });
  }

  load() {
    this.mediator.publish('startedLoading');

    return ajax(this.requestUrl, {
      basicid: this.basicIds,
      per_page: 6,
      per_index: 0,
    });
  }

  render(news) {
    if (news.length) this.container.classList.remove(this.hideClass);
    this.topNewsContainer.innerHTML = '';
    this.secondaryNewslist.innerHTML = '';

    this.topNewsContainer.classList[this.showTopNews ? 'remove' : 'add'](this.hideClass);

    news.map((data, index) => {
      const isTopNews = this.showTopNews && index === 0;
      const newsElement = document.createElement('div');
      const targetContainer = isTopNews ? this.topNewsContainer : this.secondaryNewslist;
      targetContainer.insertAdjacentElement('beforeend', newsElement);

      new NewsItem({
        parent: this,
        data: data,
        element: newsElement,
        translations: this.translations,
        user: this.user,
        isTopNews: isTopNews
      });
    });
  }
}